import dayjs from "dayjs";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { formArrayName } from "./utils/constant";

export const scheduleReportValidationSchema = (report_id?: boolean) => yupResolver(Yup.object().shape({
  [formArrayName]: Yup.object().shape({
    report_id: report_id ? Yup.string().required("Report is required") : Yup.string(),
    name: Yup.string().required("Report name is required"),
    subject: Yup.string(),
    schedule_date: Yup.mixed()
      .required("Date is required")
      .test("is-future-date", "Date cannot be in the past", (value) => {
        if (!value) return false;
        const selectedDate = dayjs(value).startOf("day");
        const today = dayjs().startOf("day");
        return selectedDate.isSame(today) || selectedDate.isAfter(today);
      }),
    schedule_time: Yup.mixed()
      .required("Time is required")
      .test("is-future-time", "Time cannot be in the past", function (value) {
        const { schedule_date } = this.parent;
        if (!value || !schedule_date) return false;

        const selectedDate = dayjs(schedule_date).startOf("day");
        const today = dayjs().startOf("day");

        // If the date is in the future, any time is valid
        if (selectedDate.isAfter(today)) {
          return true;
        }

        // If the date is today, check if the time is in the future
        const now = dayjs();
        const selectedTime = dayjs(value);
        const selectedDateTime = dayjs(schedule_date)
          .hour(selectedTime.hour())
          .minute(selectedTime.minute())
          .second(0);

        return selectedDateTime.isAfter(now);
      }),
    email: Yup.array(),
    emails: Yup.string()
      .test('emails-required', 'Email is required', function(value) {
        const { email } = this.parent;
        if (!email?.length && !value) {
          return false;
        }
        return true;
      }),
    is_recurring: Yup.boolean(),
    autopost: Yup.string().when("is_recurring", {
      is: true,
      then: (schema) => schema.required("Auto post is required"),
      otherwise: (schema) => schema.optional().nullable()
    })
  })
}));

// export const validationSchema = Yup.object().shape({
//   name: Yup.string().required("Report name is required"),
//   subject: Yup.string(),
//   schedule_date: Yup.string().required("Date is required"),
//   schedule_time: Yup.string().required("Time is required"),
//   email: Yup.array(),
//   emails: Yup.string().when("email", ([email], schema) => {
//     if (!email?.length)
//       return schema.email("Invalid email").required("Email are required");
//     return schema.email("Invalid email").nullable();
//   }),
//   is_recurring: Yup.boolean(),
//   autopost: Yup.string().when("is_recurring", (is_recurring, schema) => {
//     if (is_recurring[0]) return schema.required("Auto post is required");
//     return schema;
//   }),
// });
